<template>
  <AboutView :title="'举报'">
    <div class="report-box">
    <textarea></textarea>
    <button @click="report">提交</button>
    </div>
  </AboutView>
</template>
<script>
  import AboutView from './AboutView'
  export default {
    components: { AboutView },
    methods: {
      report () {
        alert("感谢您的反馈！");
      }
    }
  }
</script>
<style lang="scss" scoped>
  .report-box {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    padding: 0 28px;
    textarea {
      box-sizing: border-box;
      width: 100%;
      border: 1px solid;
      height: 195px;
      font-size: 14px;
      line-height: 28px;
      padding: 5px 10px;
    }
    button {
      width: 70px;
      height: 28px;
      line-height: 28px;
      margin-top: 10px;
      font-weight: 600;
      background: #F64690;
      color: white;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/About/Report.vue